'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgPause = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M3.333 0c-1.107 0-2 .893-2 2v12c0 1.107.893 2 2 2h1.333c1.107 0 2-.893 2-2V2c0-1.107-.893-2-2-2H3.333Zm8 0c-1.107 0-2 .893-2 2v12c0 1.107.893 2 2 2h1.333c1.107 0 2-.893 2-2V2c0-1.107-.893-2-2-2h-1.333Z",
  fill: "currentColor"
})));

exports["default"] = SvgPause;
